import React from 'react';
import Logo from './Logo';

const Hero = () => {
  return (
    <div className="relative bg-[#232323] text-white py-20 overflow-hidden before:content-[''] before:absolute before:inset-0 before:bg-[linear-gradient(#232323f2,#232323f2),url(https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=2000&q=80)] before:bg-cover before:bg-center before:bg-no-repeat before:z-0">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <Logo className="w-32 h-32 mx-auto mb-6" />
          <h1 className="text-4xl md:text-6xl font-bold mb-4">
            Welcome to <span className="text-[#EC6224]">QuantumBytz</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Your gateway to the future of technology. Explore the latest in quantum computing,
            Linux innovations, and cutting-edge tech developments.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Hero;